"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var advanced_display_logic_html_1 = __importDefault(require("./advanced-display-logic.html"));
var display_logic_modal_html_1 = __importDefault(require("./display-logic-modal/display-logic-modal.html"));
require("./display-logic-modal/display-logic-modal.less");
require("./advanced-display-logic.less");
(function (module) {
    'use strict';
    var AdvancedDisplayLogicController = function (modal, $scope, $rootScope, displayLogicService, globalOptions) {
        var $ctrl = this;
        $scope.$ctrl = $ctrl;
        $ctrl.openModal = function () {
            var displayLogicModal = modal({
                scope: _.merge($rootScope.$new(), {
                    displayLogic: this.displayLogic,
                    setDisplayLogic: this.setDisplayLogic,
                    sourceId: this.sourceId
                }),
                templateUrl: display_logic_modal_html_1.default,
                controller: 'prDisplayLogicModalController'
            });
            displayLogicModal.show();
        };
        $ctrl.advancedApplied = function () {
            return displayLogicService.isValidID(this.displayLogic);
        };
        $ctrl.getDisplayLogicLabel = function () {
            var displayLogic = displayLogicService.getDisplayLogic(this.displayLogic);
            return displayLogic && displayLogic.name;
        };
        $ctrl.canApplyAdvanced = function () {
            var _a;
            return !!((_a = this.displayLogic) === null || _a === void 0 ? void 0 : _a.enabled);
        };
        $ctrl.removeAdvanced = function () {
            // when advanced is removed, apply custom rule and default responsethreshold
            var globalDisplayLogic = globalOptions.getDisplayLogic();
            this.displayLogic = {
                enabled: true,
                responseThreshold: globalDisplayLogic && globalDisplayLogic.responseThreshold || 0
            };
            this.setDisplayLogic({
                displayLogic: this.displayLogic
            });
        };
    };
    AdvancedDisplayLogicController.$inject = [
        'qstrap.modal',
        '$scope',
        '$rootScope',
        'prDisplayLogicService',
        'pr.globalOptionsService'
    ];
    module.component('prAdvancedDisplayLogic', {
        templateUrl: advanced_display_logic_html_1.default,
        controller: AdvancedDisplayLogicController,
        bindings: {
            setDisplayLogic: '&',
            displayLogic: '=',
            sourceId: '<'
        }
    });
})(angular.module('qualtrics.pr'));
